import React from 'react'
import { Route } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import FooterComponent from './Footer'

@inject('store')
@observer
export default class ApplieRoute extends React.Component {
  render() {
    const { component: C, props } = this.props
    const renderArr = []
    return (
      <Route
        render={cProps => {
          renderArr.push(<C key="body" {...props} {...cProps} />)
          renderArr.push(
            <FooterComponent key="footer" {...props} {...cProps} />
          )
          return renderArr
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AppliedRoute.js